var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyActionBar, ReactElementFactory, SvgIcon } from "survey-react-ui";
var QuestionWrapperHeader = /** @class */ (function (_super) {
    __extends(QuestionWrapperHeader, _super);
    function QuestionWrapperHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuestionWrapperHeader.prototype.render = function () {
        var _this = this;
        if (!this.props.model.allowDragging)
            return null;
        return (React.createElement("div", { className: "svc-question__drag-area", onPointerDown: function (event) {
                return _this.props.model.onPointerDown(event);
            } },
            React.createElement(SvgIcon, { className: "svc-question__drag-element", size: "auto", iconName: "icon-drag-area-indicator_24x16" }),
            React.createElement("div", { className: "svc-question__top-actions" },
                React.createElement(SurveyActionBar, { model: this.props.model.topActionContainer, handleClick: false }))));
    };
    return QuestionWrapperHeader;
}(React.Component));
export { QuestionWrapperHeader };
ReactElementFactory.Instance.registerElement("svc-question-header", function (props) {
    return React.createElement(QuestionWrapperHeader, props);
});
